import React from 'react'
import Container from './../container.component'

export default function InnerPageContainer({ children, ...props }) {
	return (
		<Container style={{ paddingBottom: '5rem' }} {...props}>
			{children}
		</Container>
	)
}
